import {
  Box,
  Container,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React from "react";
import { icons, images, videos } from "../../assets";
import { allColors } from "../../constants";
import GlobalButton from "./../../components/globalButton/index";
import { mediaUrl } from "../../constants/variables";

const OurTrustPartner = () => {
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  return (
    <Container
      sx={{
        maxWidth: "1300px !important",
        marginTop: "40px",
        position: "relative",
      }}
    >
      <Box
        sx={{
          borderRadius: "35px",
          marginTop: "60px",
          padding: "30px 0px 0px 0px",
          textAlign: "center",
        }}
      >
        <Typography
          sx={{
            fontSize: { xs: "35px", md: "50px" },
            fontWeight: "400",
            color: allColors.jetBlack,
            fontFamily: "Raleway",
          }}
        >
          Our Trusted Partners
        </Typography>
      </Box>

      <Box
        sx={{
          mt: "10px",
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img
          src={images.trustPartnerImg}
          alt="trust partner"
          style={{ width: isSmallScreen ? "108%" : "60%", height: "100%" }}
        />
      </Box>
    </Container>
  );
};

export default OurTrustPartner;
